<div class="knowledge-base">
    <div class="knowledge-base__header">
        <bzg-icon [nameIcon]="'icon-ai-knowledge'" class="icon-ai-tools" [size]="32"></bzg-icon>
        <h2 class="knowledge-base__title">{{ 'AIFORPROCESSES.KNOWLEDGE.TITLE' | translate }}</h2>
    </div>
    
    <div class="knowledge-base__category" *ngFor="let category of knowledgeCategories; let i = index;let last = last">
        <div [ngClass]="(last?'knowledge-base__section-container-last':'knowledge-base__section-container')">
            <div class="knowledge-base__category-header">
                <bzg-checkbox 
                    [id]="'cat-' + i" 
                    [(ngModel)]="category.Selected"
                    [checked]="category.Selected"
                    [disabled]="true"
                    [hidden]="isEnvironmentCategory(category)">
                </bzg-checkbox>
                <label class="knowledge-base__category-title" for="cat-{{ i }}">{{ category.DisplayName }}</label>
                <span *ngIf="isCategoryInherited(category)"
                    class="knowledge-base__inheritance-indicator knowledge-base__tooltip"
                    [attr.data-tooltip]="getCategoryInheritanceTooltip(category)">
                    {{ 'AIFORPROCESSES.INHERITED' | translate }}
                </span>
                <div class="knowledge-base__section-toggle-button">
                    <button class="knowledge-base__toggle-button" (click)="toggleCollapse(i)">
                        <span
                            [ngClass]="{ 'knowledge-base__arrow-down': getToogleCollapse(i), 'knowledge-base__arrow-up': !getToogleCollapse(i) }"></span>
                    </button>
                </div>
            </div>
            
            <div *ngIf="!getToogleCollapse(i)">
                <div *ngIf="!category.KBCatalogs || category.KBCatalogs.length === 0" class="knowledge-base__no-catalogs">
                    <span class="knowledge-base__no-catalogs-text">{{ 'AIFORPROCESSES.KNOWLEDGE.NO_CATALOGS' | translate }}</span>
                </div>
                <div class="knowledge-base__cards">
                    <div class="knowledge-base__card" [class.knowledge-base__card--selected]="catalog.Selected" *ngFor="let catalog of category.KBCatalogs">
                        <div class="knowledge-base__card-content">
                            <div class="knowledge-base__card-header">
                                <bzg-checkbox 
                                    [id]="catalog.Id" 
                                    [(ngModel)]="catalog.Selected"
                                    [checked]="catalog.Selected"
                                    (ngModelChange)="onCatalogSelectionChange(category.Id, catalog.Id, $event)"
                                    [disabled]="!category.EditMode">
                                </bzg-checkbox>
                                <bzg-icon [nameIcon]="'icon-ai-folder'" 
                                    [size]="16">
                                </bzg-icon>
                                <div class="knowledge-base__card-title">
                                    <div class="knowledge-base__card-title-row">
                                        <span class="knowledge-base__card-title-name">{{ catalog.DisplayName}}</span>
                                        <span *ngIf="isCatalogInherited(catalog)"
                                            class="knowledge-base__inheritance-indicator knowledge-base__tooltip"
                                            [attr.data-tooltip]="getCatalogInheritanceTooltip(catalog)">
                                            {{ 'AIFORPROCESSES.INHERITED' | translate }}
                                        </span>
                                    </div>
                                    <!-- Commented out until static knowledge base functionality is implemented -->
                                    <!-- <span class="knowledge-base__card-title-static">{{ 'AIFORPROCESSES.STATIC' | translate }}</span> -->
                                </div>
                                <bzg-icon 
                                    class="knowledge-base__reset-icon knowledge-base__tooltip"
                                    *ngIf="catalog.CanReset && category.EditMode"
                                    [nameIcon]="'icon-ai-reset'"
                                    [size]="10"
                                    (click)="onRemoveAIBpmKnowledgeBaseEnvironmentItem(category.Id, catalog.Id)"
                                    [attr.data-tooltip]="'AIFORPROCESSES.KNOWLEDGE.RESET_TO_INHERITED' | translate">
                                </bzg-icon>
                            </div>
                            <div class="knowledge-base__card-desc text-truncate">{{ catalog.Description }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>
